// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__hzjy9","list":"PatternAutocomplete_list__39q_C"};